import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Badge/Badge.tsx
import React, { forwardRef } from "react";
import clsx from "clsx";
var DEFAULT_COMPONENT = "span";
var BADGE_CLASSNAME_MAP = {
  variant: {
    info: "pd-bg-info-500",
    "info-outline": "pd-bg-white pd-border-info-500 pd-text-info-600",
    "info-circle": "pd-size-5 pd-px-2 pd-bg-info-500",
    success: "pd-bg-success-500",
    "success-outline": "pd-bg-white pd-border-success-500 pd-text-success-600",
    "success-circle": "pd-size-5 pd-px-2 pd-bg-success-500",
    primary: "pd-bg-primary-500",
    "primary-outline": "pd-bg-white pd-border-primary-500 pd-text-primary-600",
    "primary-circle": "pd-size-5 pd-px-2 pd-bg-primary-500",
    "primary-outline-circle": "pd-size-5 pd-px-2 pd-bg-white pd-border-primary-500 pd-text-primary-600",
    dim: "pd-bg-dim-500",
    "dim-outline": "pd-bg-white pd-border-dim-500 pd-text-dim-800",
    "dim-circle": "pd-size-5 pd-px-2 pd-bg-dim-500",
    error: "pd-bg-error-500",
    warning: "pd-bg-warning-500 pd-text-dim-800"
  }
};
var Badge = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      variant = "info",
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "variant", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */React.createElement(Component, __spreadValues({
    ref,
    className: clsx("pd-badge", BADGE_CLASSNAME_MAP.variant[variant], className)
  }, rest), children);
});
var StoryBadge = args => /* @__PURE__ */React.createElement(Badge, __spreadValues({}, args));
var Badge_default = Badge;
export { BADGE_CLASSNAME_MAP, StoryBadge, Badge_default };